export default __webpack_public_path__ + "static/media/quote2.874abc84.jpg";